/*
 * @Author: 彭鑫诚
 * @Date: 2024-06-28 14:36:16
 * @LastEditors: 彭鑫诚
 * @LastEditTime: 2024-07-08 10:52:24
 * @Description: file content
 */
import type { IRequestOrderGuideModel } from '@monorepo/types/orders/replenishmentGuide/index.type';
import {
  OrderAmountType,
  OrderVariantType,
  RequestOrderType,
  type IRequestOrderGuideStore,
} from '@monorepo/types/orders/replenishmentGuide/index.type';
import { getToday } from '@monorepo/utils';

const initState: IRequestOrderGuideStore = {
  productForm: {
    in_location_id: '',
    is_out_location_has: false,
    item_search_template_id: '',
    no_stock_day_num: '1',
    order_amount_type: OrderAmountType.Zero,
    order_variant_type: OrderVariantType.Location,
    out_location_id: '',
    request_order_type: RequestOrderType.Location,
    variant_date: getToday(),
    amount_date: getToday(),
  },
  productList: [],
  orderList: [],
};

const requestOrderGuideStore: IRequestOrderGuideModel = {
  namespace: 'requestOrderGuideStore',
  state: initState,
  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
    update(state, { payload }) {
      return { ...state, ...payload };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default requestOrderGuideStore;
